import { useMemo } from 'react';

import { permissions, strings } from 'common';
import Button from 'components/shared/Button';
import PermissionsGate from 'components/shared/PermissionsGate';
import { Task, TaskStatus } from 'models';
import { canApproveTask } from 'utils/tasks';

interface ApproveButtonProps {
  selectedIds: string[];
  tasks: Task[];
  loading: boolean;
  onClick: (status: TaskStatus) => void;
}

const ApproveButton: React.FC<ApproveButtonProps> = (props) => {
  const { selectedIds, tasks, loading, onClick } = props;

  const disabled = useMemo(() => {
    if (!selectedIds.length) {
      return true;
    }
    return !selectedIds.every((id) => {
      const task = tasks.find((task) => task.id === id);
      return canApproveTask(task!);
    });
  }, [selectedIds, tasks]);

  return (
    <PermissionsGate permissions={[permissions.INVENTORY_VDP_TASKS_APPROVE]}>
      <Button
        className="FlatTasks-action-button FlatTasks-action-button-approve"
        id="approve-task-button"
        type="button"
        variant="success"
        onClick={() => onClick('APPROVED_PENDING_COMPLETE')}
        disabled={disabled}
        loading={loading}
      >
        {strings.APPROVE}
      </Button>
    </PermissionsGate>
  );
};

export default ApproveButton;
